"use strict";
function CPF(cpf) {
    return {
        raw: cpf,
        get mask() {
            if (!cpf)
                return "";
            return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
        },
        get unmask() {
            if (!cpf)
                return "";
            return cpf.replace(/[^\d]+/g, "");
        },
        get validate() {
            if (!cpf)
                return false;
            const valueNumber = cpf?.replace(/[^\d]+/g, "");
            if (valueNumber?.length !== 11 || !Array.from(valueNumber).filter((e) => e !== valueNumber[0]).length) {
                return false;
            }
            const values = valueNumber.split("").map((el) => +el);
            const rest = (count) => ((values.slice(0, count - 12).reduce((soma, el, index) => soma + el * (count - index), 0) * 10) % 11) % 10;
            return rest(10) === values[9] && rest(11) === values[10];
        },
    };
}
window.CPF = CPF;
//# sourceMappingURL=index.js.map